import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Button, Input } from "reactstrap";
// @ts-ignore
import back from "../assets/back.png";
import Api from "./api/api";
import MyLoader from "./util/loader";
import MyStorage from "./util/storage";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import ListItemContainer from "./common/ListItemContainer";
import ListItemActionButton from "./common/ListItemActionButton";
import useReorder from "../hooks/use-reorder";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import PageActionButton from "./common/PageActionButton";

const GuideVideos = () => {
  let filePath = MyStorage.getFileUrls().LibraryImages;
  var history = useHistory();

  const [models, setModels] = useState([]);
  const [loader, setLoader] = useState(false);

  const [editVideoId, setEditVideoId] = useState("");
  const [editVideoTitle, setEditVideoTitle] = useState("");

  const { isReordering, toggleIsReordering, reorderedItems, onReorderEnd, saveOrdering } =
    useReorder({
      items: models,
      onSave: (data) =>
        Api.updateGuideVideoOrder({
          params: { data },
          onSuccess: () => {
            showToast("success", "Ordering is updated!");
            loadData();
            setTimeout(() => toggleIsReordering(), 1000);
          },
          onError: () => {
            loadData();
            toggleIsReordering();
          },
        }),
    });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    Api.getGuideVideos(
      (response) => {
        console.log(JSON.stringify(response));
        setLoader(false);
        setModels(response.data);
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const deleteVideo = (video) => {
    if (window.confirm("Are you sure you wish to delete this video?")) {
      setLoader(true);
      Api.deleteGuideVideo(
        video.id,
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Video deleted!");
            loadData();
          }
        },
        (error) => {
          setLoader(false);
          showToast("error", "Request failed!");
        }
      );
    }
  };

  const updateVideoTitle = (video, title) => {
    setLoader(true);
    Api.updateGuideVideoTitle({
      params: { video_id: video.id, title: title },
      onSuccess: (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Video title updated!");
          const list = models.map((item) => {
            if (item.id === video.id) {
              return { ...item, title: title };
            } else {
              return item;
            }
          });
          setModels(list);
        }
      },
      onError: (error) => {
        setLoader(false);
        showToast("error", "Request failed!");
      },
    });
  };

  const renderVideoElement = (model, index) => {
    return (
      <GuideVideoItem
        index={index}
        model={model}
        editVideoId={editVideoId}
        editVideoTitle={editVideoTitle}
        setEditVideoId={setEditVideoId}
        updateVideoTitle={updateVideoTitle}
        deleteVideo={deleteVideo}
        setEditVideoTitle={setEditVideoTitle}
      />
    );
  };

  const SortableItem = SortableElement(({ value, ...rest }) => {
    return renderVideoElement(value, rest.index2);
  });

  const SortableList = SortableContainer(({ items }) => (
    <div>
      {items.map((value, index) => {
        return <SortableItem key={value.id} index={index} value={value} index2={index} />;
      })}
    </div>
  ));

  return (
    <div className="main">
      <div className="titlebar" style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}>
        <div style={{ color: "blue" }}>Guide Videos</div>
      </div>
      <div style={{ marginTop: 20 }}>
        <img
          onClick={() => {
            console.log("click");
            history.goBack();
          }}
          src={back}
          style={{ width: 30, height: 30, marginTop: 10, marginRight: 10 }}
          className="icon-btn"
        />
        <Button
          className="btn-block btn-submit"
          style={{ width: 150, borderWidth: 0, marginTop: 10, fontSize: 16, marginRight: 10 }}
          onClick={() => {
            console.log("click");
            history.push({
              pathname: "/upload-videos",
              state: { model: null, guide: true },
            });
          }}
        >
          Add Videos
        </Button>
        {isReordering ? (
          <>
            <PageActionButton
              color={"blue"}
              onClick={() => {
                saveOrdering();
                // toggleIsReordering();
              }}
              text={"Save Order"}
            />

            <PageActionButton color={"red"} onClick={toggleIsReordering} text={"Cancel"} />
          </>
        ) : (
          <PageActionButton color={"blue"} onClick={toggleIsReordering} text={"Reorder"} />
        )}
        <div style={{ marginTop: 10 }}></div>
        {isReordering && <SortableList items={reorderedItems} axis="xy" onSortEnd={onReorderEnd} />}
        {!isReordering &&
          models.map((model, index) => {
            return renderVideoElement(model, index);
          })}{" "}
      </div>
      <MyLoader loader={loader} marginTop={0} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

const GuideVideoItem = ({
  index,
  model,
  editVideoId,
  editVideoTitle,
  setEditVideoTitle,
  setEditVideoId,
  updateVideoTitle,
  deleteVideo,
}) => {
  var history = useHistory();

  return (
    <ListItemContainer index={index} extraClassName="item-btn">
      <div style={{ marginTop: 0, display: "flex", width: "100%", userSelect: "none" }}>
        {/* <div className="item-btn" style={{ display: "flex", flexDirection: "column" }}> */}
        <div
          className="projects-item-photo"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={model.thumbnail}
            style={{
              padding: 1,
              width: 70,
              height: 70,
              objectFit: "cover",
            }}
            alt=""
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div className="projects-item-cat" style={{ flexGrow: 0 }}>
            <div style={{ fontSize: 14 }}>ID: {model.id}</div>
          </div>
          <div className="projects-item-cat" style={{ flexGrow: 0 }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {editVideoId === model.id ? (
                <Input
                  type="text"
                  placeholder="Edit Title"
                  style={{ minWidth: 400, fontSize: 14 }}
                  value={editVideoTitle}
                  onChange={(event) => {
                    setEditVideoTitle(event.target.value);
                  }}
                />
              ) : (
                <div style={{ fontSize: 16 }}>{model.title}</div>
              )}
              {editVideoId === model.id ? (
                <button
                  onClick={() => {
                    console.log("update title");
                    let newTitle = editVideoTitle;
                    updateVideoTitle(model, newTitle);
                    setEditVideoTitle("");
                    setEditVideoId("");
                  }}
                  style={{
                    alignSelf: "flex-start",
                    fontSize: 16,
                    color: "blue",
                    backgroundColor: "transparent",
                    border: "0px",
                  }}
                >
                  Save
                </button>
              ) : (
                <button
                  onClick={() => {
                    setEditVideoTitle(model.title);
                    setEditVideoId(model.id);
                  }}
                  style={{
                    alignSelf: "flex-start",
                    padding: 0,
                    fontSize: 16,
                    color: "blue",
                    backgroundColor: "transparent",
                    border: "0px",
                  }}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="projects-item-cat" style={{ display: "flex", justifyContent: "flex-end" }}>
          <ListItemActionButton
            color="gray"
            onClick={() =>
              history.push({
                pathname: "/play-video",
                state: { model: model },
              })
            }
          >
            View
          </ListItemActionButton>

          <ListItemActionButton color="red" onClick={() => deleteVideo(model)}>
            Delete
          </ListItemActionButton>
        </div>
        {/* </div> */}
      </div>
    </ListItemContainer>
  );
};

export default GuideVideos;
